export default [
  {
    path: "/project/:proj_id",
    component: () => import("@/layouts/ProjectLayout.vue"),
    meta: {
      authRequired: true,
    },
    children: [
      // ========== 자료실 ============
      {
        path: "filelibrary/320",
        name: "filelibrary-320",
        meta: {
          activeCode: "filelibrary-320",
          boardId: 320,
        },
        component: () => import("@/views/filelibrary/FileLibraryList.vue"),
      },
      {
        path: "filelibrary/321",
        name: "filelibrary-321",
        meta: {
          activeCode: "filelibrary-321",
          boardId: 321,
        },
        component: () => import("@/views/filelibrary/FileLibraryList.vue"),
      },
      {
        path: "filelibrary/322",
        name: "filelibrary-322",
        meta: {
          activeCode: "filelibrary-322",
          boardId: 322,
        },
        component: () => import("@/views/filelibrary/FileLibraryList.vue"),
      },
      {
        path: "filelibrary/323",
        name: "filelibrary-323",
        meta: {
          activeCode: "filelibrary-323",
          boardId: 323,
        },
        component: () => import("@/views/filelibrary/FileLibraryList.vue"),
      },
      {
        path: "filelibrary/324",
        name: "filelibrary-324",
        meta: {
          activeCode: "filelibrary-324",
          boardId: 324,
        },
        component: () => import("@/views/filelibrary/FileLibraryList.vue"),
      },
      {
        path: "filelibrary/325",
        name: "filelibrary-325",
        meta: {
          activeCode: "filelibrary-325",
          boardId: 325,
        },
        component: () => import("@/views/filelibrary/FileLibraryList.vue"),
      },
      {
        path: "filelibrary/340",
        name: "filelibrary-340",
        meta: {
          activeCode: "filelibrary-340",
          boardId: 340,
        },
        component: () => import("@/views/filelibrary/FileLibraryList.vue"),
      },
      {
        path: "filelibrary/341",
        name: "filelibrary-341",
        meta: {
          activeCode: "filelibrary-341",
          boardId: 341,
        },
        component: () => import("@/views/filelibrary/FileLibraryList.vue"),
      },
      {
        path: "filelibrary/342",
        name: "filelibrary-342",
        meta: {
          activeCode: "filelibrary-342",
          boardId: 342,
        },
        component: () => import("@/views/filelibrary/FileLibraryList.vue"),
      },
      {
        path: "filelibrary/343",
        name: "filelibrary-343",
        meta: {
          activeCode: "filelibrary-343",
          boardId: 343,
        },
        component: () => import("@/views/filelibrary/FileLibraryList.vue"),
      },
      {
        path: "filelibrary/347",
        name: "filelibrary-347",
        meta: {
          activeCode: "filelibrary-347",
          boardId: 347,
        },
        component: () => import("@/views/filelibrary/FileLibraryList.vue"),
      },

      // 신규자료실
      // 안전보건 점검 12345
      {
        path: "filelibrary/413",
        name: "filelibrary-413",
        meta: {
          activeCode: "filelibrary-413",
          boardId: 413,
        },
        component: () => import("@/views/filelibrary/FileLibraryList.vue"),
      },
      {
        path: "filelibrary/414",
        name: "filelibrary-414",
        meta: {
          activeCode: "filelibrary-414",
          boardId: 414,
        },
        component: () => import("@/views/filelibrary/FileLibraryList.vue"),
      },
      {
        path: "filelibrary/415",
        name: "filelibrary-415",
        meta: {
          activeCode: "filelibrary-415",
          boardId: 415,
        },
        component: () => import("@/views/filelibrary/FileLibraryList.vue"),
      },
      {
        path: "filelibrary/416",
        name: "filelibrary-416",
        meta: {
          activeCode: "filelibrary-416",
          boardId: 416,
        },
        component: () => import("@/views/filelibrary/FileLibraryList.vue"),
      },
      {
        path: "filelibrary/417",
        name: "filelibrary-417",
        meta: {
          activeCode: "filelibrary-417",
          boardId: 417,
        },
        component: () => import("@/views/filelibrary/FileLibraryList.vue"),
      },

      // 안전·보건 교육 12345
      {
        path: "filelibrary/418",
        name: "filelibrary-418",
        meta: {
          activeCode: "filelibrary-418",
          boardId: 418,
        },
        component: () => import("@/views/filelibrary/FileLibraryList.vue"),
      },
      {
        path: "filelibrary/419",
        name: "filelibrary-419",
        meta: {
          activeCode: "filelibrary-419",
          boardId: 419,
        },
        component: () => import("@/views/filelibrary/FileLibraryList.vue"),
      },
      {
        path: "filelibrary/420",
        name: "filelibrary-420",
        meta: {
          activeCode: "filelibrary-420",
          boardId: 420,
        },
        component: () => import("@/views/filelibrary/FileLibraryList.vue"),
      },
      {
        path: "filelibrary/421",
        name: "filelibrary-421",
        meta: {
          activeCode: "filelibrary-421",
          boardId: 421,
        },
        component: () => import("@/views/filelibrary/FileLibraryList.vue"),
      },
      {
        path: "filelibrary/422",
        name: "filelibrary-422",
        meta: {
          activeCode: "filelibrary-422",
          boardId: 422,
        },
        component: () => import("@/views/filelibrary/FileLibraryList.vue"),
      },

      // 관련 법령 등 12345
      {
        path: "filelibrary/423",
        name: "filelibrary-423",
        meta: {
          activeCode: "filelibrary-423",
          boardId: 423,
        },
        component: () => import("@/views/filelibrary/FileLibraryList.vue"),
      },
      {
        path: "filelibrary/424",
        name: "filelibrary-424",
        meta: {
          activeCode: "filelibrary-424",
          boardId: 424,
        },
        component: () => import("@/views/filelibrary/FileLibraryList.vue"),
      },
      {
        path: "filelibrary/425",
        name: "filelibrary-425",
        meta: {
          activeCode: "filelibrary-425",
          boardId: 425,
        },
        component: () => import("@/views/filelibrary/FileLibraryList.vue"),
      },
      {
        path: "filelibrary/426",
        name: "filelibrary-426",
        meta: {
          activeCode: "filelibrary-426",
          boardId: 426,
        },
        component: () => import("@/views/filelibrary/FileLibraryList.vue"),
      },
      {
        path: "filelibrary/427",
        name: "filelibrary-427",
        meta: {
          activeCode: "filelibrary-427",
          boardId: 427,
        },
        component: () => import("@/views/filelibrary/FileLibraryList.vue"),
      },

      // 관련 법령 등 12345
      {
        path: "filelibrary/428",
        name: "filelibrary-428",
        meta: {
          activeCode: "filelibrary-428",
          boardId: 428,
        },
        component: () => import("@/views/filelibrary/FileLibraryList.vue"),
      },
      {
        path: "filelibrary/429",
        name: "filelibrary-429",
        meta: {
          activeCode: "filelibrary-429",
          boardId: 429,
        },
        component: () => import("@/views/filelibrary/FileLibraryList.vue"),
      },
      {
        path: "filelibrary/430",
        name: "filelibrary-430",
        meta: {
          activeCode: "filelibrary-430",
          boardId: 430,
        },
        component: () => import("@/views/filelibrary/FileLibraryList.vue"),
      },
      {
        path: "filelibrary/431",
        name: "filelibrary-431",
        meta: {
          activeCode: "filelibrary-431",
          boardId: 431,
        },
        component: () => import("@/views/filelibrary/FileLibraryList.vue"),
      },
      {
        path: "filelibrary/432",
        name: "filelibrary-432",
        meta: {
          activeCode: "filelibrary-432",
          boardId: 432,
        },
        component: () => import("@/views/filelibrary/FileLibraryList.vue"),
      },

      {
        path: "filelibrary/454",
        name: "filelibrary-454",
        meta: {
          activeCode: "filelibrary-454",
          boardId: 454,
        },
        component: () => import("@/views/filelibrary/FileLibraryList.vue"),
      },
      {
        path: "filelibrary/455",
        name: "filelibrary-455",
        meta: {
          activeCode: "filelibrary-455",
          boardId: 455,
        },
        component: () => import("@/views/filelibrary/FileLibraryList.vue"),
      },
      {
        path: "filelibrary/1094",
        name: "filelibrary-1094",
        meta: {
          activeCode: "filelibrary-1094",
          boardId: 1094,
        },
        component: () => import("@/views/filelibrary/FileLibraryList.vue"),
      },
    ],
  },
];
